// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1nK78","additionalInfo":"AgreementModal_additionalInfo__3fqIt"};